import script from "./CreateTicketModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateTicketModal.vue?vue&type=script&setup=true&lang=ts"

import "./CreateTicketModal.vue?vue&type=style&index=0&id=29189082&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29189082"]])

export default __exports__